import { useEffect, useState } from 'react';
import { speechToTxtApi } from './api/index';

const useSpeechToTxt = props => {
  const { trackId, currentConvId } = props;

  const [currentSpeechData, setCurrentSpeechData] = useState({});

  const changeCurrentSpeechData = (message_id, type, data) => {
    let obj = {};
    if (type === 'speeching') {
      obj[message_id] = {
        msg_id: message_id,
        speeching: true
      };
    } else if (type === 'speeched') {
      obj[message_id] = {
        msg_id: message_id,
        speeching: false,
        ...data
      };
    } else if (type === 'fail') {
      obj[message_id] = {
        msg_id: message_id,
        speeching: false,
        fail: true
      };
    }
    return obj;
  };

  const handleSpeechToTxt = message_id => {
    setCurrentSpeechData(currentSpeechData => ({
      ...currentSpeechData,
      ...changeCurrentSpeechData(message_id, 'speeching')
    }));
    return new Promise((resolve, reject) => {
      speechToTxtApi(message_id)
        .then(resp => {
          if (resp.data) {
            setCurrentSpeechData(currentSpeechData => ({
              ...currentSpeechData,
              ...changeCurrentSpeechData(message_id, 'speeched', resp.data)
            }));
            resolve(resp.data);
          } else {
            reject();
          }
        })
        .catch(e => {
          setCurrentSpeechData(currentSpeechData => ({
            ...currentSpeechData,
            ...changeCurrentSpeechData(message_id, 'fail')
          }));
          reject(e);
        });
    });
  };

  useEffect(() => {
    setCurrentSpeechData({});
  }, [trackId, currentConvId]);

  return {
    currentSpeechData,
    handleSpeechToTxt
  };
};

export default useSpeechToTxt;
